export default {
  setUsers(state, payload) {
    state.users = payload;
  },
  setPagination(state, payload) {
    state.pagination = payload;
  },
  addUser(state, payload) {
    state.users.unshift(payload);
  },
  updateUser(state, payload) {
    const index = state.users.findIndex(
      (item) => item.username === payload.username
    );
    if (index !== -1) {
      // Merge updates — preserve fields not in payload
      state.users[index] = { ...state.users[index], ...payload };
    }
  },
  deleteUser(state, username) {
    const index = state.users.findIndex((item) => item.username === username);
    if (index !== -1) {
      state.users[index].is_deleted = 1;
    }
  },
  changeUserStatus(state, payload) {
    const index = state.users.findIndex(
      (item) => item.username === payload.username
    );
    if (index !== -1) {
      // Normalize boolean (from base-toggle) and number callers to 0/1 so the
      // status filter `user.status === 1` keeps working without a reload.
      state.users[index].status = payload.status ? 1 : 0;
    }
  },
  changeUserLoginStatus(state, payload) {
    const index = state.users.findIndex(
      (item) => item.username === payload.username
    );
    if (index !== -1) {
      state.users[index].isLoggedIn = payload.isLoggedIn ? 1 : 0;
    }
  },
  // Mirror the post-update truth from the blacklist endpoint. The backend
  // flips both columns atomically on a 0→1 blacklist (status auto-goes to
  // 0); on a 1→0 unblacklist only the flag changes. Either way the
  // response payload is authoritative — apply both fields when present.
  changeUserBlacklist(state, payload) {
    const index = state.users.findIndex(
      (item) => item.username === payload.username
    );
    if (index === -1) return;
    state.users[index].blacklisted_by_vendor = payload.blacklisted_by_vendor
      ? 1
      : 0;
    if (payload.status !== undefined && payload.status !== null) {
      state.users[index].status = payload.status ? 1 : 0;
    }
  },
};
